import { useAppDispatch, useAppSelector } from "../../app";
import { useCallback } from "react";
import activeDocumentIdSelector from "../../document/selectors/activeDocumentIdSelector";
import { removeAnnotationFromState } from "../../annotation/store/annotationSlice";
import annotationForIdSelector from "../../annotation/selectors/annotationForIdSelector";
import documentSetDisabledSelector from "../../documentSet/selectors/documentSetDisabledSelector";
import { incrementOperations } from "../../analytics/store/analyticsSlice";
import { changeHasBeenEdited } from "../../app/store/appSlice";
import { shallowEqual } from "react-redux";
import { trackButtonClick } from "../../common/utilities/tracking";

const useRemoveAnnotation = (annotationId: string) => {
  const dispatch = useAppDispatch();

  const disabled = useAppSelector(documentSetDisabledSelector, shallowEqual);
  const documentId = useAppSelector(activeDocumentIdSelector, shallowEqual);
  const annotation = useAppSelector(
    (state) => annotationForIdSelector(state, annotationId),
    shallowEqual,
  );

  return useCallback(() => {
    if (disabled) {
      return;
    }

    if (!documentId || !annotation) {
      return;
    }

    const { multipleGroupBlocks, id } = annotation;

    dispatch(
      removeAnnotationFromState({
        annotationId: id,
        documentId,
        multipleGroupBlocks,
      }),
    );
    dispatch(changeHasBeenEdited(true));
    dispatch(
      incrementOperations({
        numberOfAdditions: 0,
        numberOfUpdates: 0,
        numberOfDeletions: 1,
      }),
    );
    trackButtonClick("annotator-annotation-remove");
  }, [dispatch, documentId, annotation, disabled]);
};

export default useRemoveAnnotation;
